<template>
  <div style="padding: 15px;">
    <div style="text-align: center; font-size: 16px;font-weight: bold">
      金融业用户风险评估问卷
    </div>
    <div style="text-align: center; font-size: 12px;padding-top: 10px;">
      得分：{{riskMsg.riskMark}}分
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      1. 您的年龄范围是？(回答：{{riskMsg.riskOne}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      2. 您的月收入水平占家庭收入的比例是(回答：{{riskMsg.riskTwo}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      3. 您的主要收入来源是？(回答：{{riskMsg.riskThree}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      4. 您的投资经验如何？(回答：{{riskMsg.riskFrou}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      5. 您投资的主要目标是？(回答：{{riskMsg.riskFive}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      6. 当投资出现短期亏损（10%以上）时，您通常会？(回答：{{riskMsg.riskSix}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      7. 您通常会将多少比例的资产用于投资？(回答：{{riskMsg.riskSeven}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      8. 您对投资期限的偏好是？(回答：{{riskMsg.riskFight}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      9. 您是否愿意投资于高波动性产品？(回答：{{riskMsg.riskNine}})
    </div>
    <div style="text-align: left; font-size: 12px;padding-top: 10px;">
      10. 您的应急资金准备情况如何？(回答：{{riskMsg.riskTen}})
    </div>
  </div>
</template>

<script>
import {axiosGet} from "@/main";
import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";

export default {
name: "RiskPage",
  data(){
    return{
      riskMsg:[]
    }
  },
  mounted(){
    let that=this
    loading("加载中")
    axiosGet(DO_NET_URL+"project/IsSetRiskAssessmentByBg?userId="+localStorage.getItem("userCode"),function (res){
      console.log(res.data)
      closeLoading()
      if(res.data==null){
        toask("用户没有签署风险协议！",6)
      }else{
        that.riskMsg=res.data
      }
    })
  },
  methods: {

  }
}
</script>

<style scoped>

</style>